import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Carousel,
  CarouselContainer,
  CarouselNextButton,
  CarouselPrevButton,
  KnowTeamNudgeData,
  NudgeAction,
  NudgeCardItem,
} from '@mesh.ai/rabbit';
import { L3_PATHS } from 'Deer/constants/routes';
import { useDispatch } from 'react-redux';
import { generatePath, Link, useHistory } from 'react-router-dom';
import { openCreateOneOnOneDrawer } from 'screens/oneOnOneRabbit/creationDrawer/slice/CreateOneOnOneDrawerSlice';

import { OneOnOne } from 'assets/assetsV1/iconComponents';
import noListData from 'assets/assetsV1/illustrations/deerIllustrations/noListData.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';

const OneOnOneIcon = (props) => <OneOnOne {...props} color="currentColor" width="24px !important" />;

const UpComingOneOnOneList = ({ oooData }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // data for non-manager entries
  const filteredData = oooData?.filter((entry) => entry.employee?.value?.relationType !== 'MANAGER');

  const handleStart = (masterId, instanceId) => {
    const path = generatePath(L3_PATHS['my-data'].oneOnOne.instancePage, {
      instanceId,
      masterId,
    });
    history.push(path);
  };

  return (
    <Card>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '8px',
        }}
      >
        <CardHeader>
          <CardTitle>1:1s with Peers</CardTitle>
        </CardHeader>
        {filteredData?.length > 0 && (
          <div>
            <Link to={L3_PATHS['my-data'].oneOnOne.myOneOnOne}>
              <Button
                style={{
                  marginLeft: 'auto',
                }}
                variant="outline"
                iconLeft={OneOnOneIcon}
              >
                View all 1:1s
              </Button>
            </Link>
          </div>
        )}
      </div>
      <CardContent>
        {!filteredData?.length ? (
          <EmptyScreen
            illustrationSrc={noListData}
            heading="No upcoming 1:1s "
            isSmallTextSize
            description="Add new 1:1s with your team members and accelerate your growth"
            illustrationStyle={{
              width: '135px',
              height: '120px',
            }}
          />
        ) : (
          <Carousel>
            <CarouselContainer prevButton={<CarouselPrevButton />} nextButton={<CarouselNextButton />}>
              {filteredData?.map((values, i) => {
                const { employee, nextOneOnOne } = values ?? {};
                const { isOneOnOneSetup, employeeMiniProfile } = employee?.value ?? '';
                const { displayName, profilePhoto, id } = employee?.value?.employeeMiniProfile ?? {};

                // eslint-disable-next-line no-unsafe-optional-chaining
                const nextInstanceTS = isOneOnOneSetup && nextOneOnOne?.value?.nextInstanceTS * 1000;

                const masterId = employee?.value?.oneOnOneMasterId;
                const instanceId = nextOneOnOne?.value?.latestInstanceId;
                const oneOnOneInstanceExists = typeof masterId === 'number' && typeof instanceId === 'number';

                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <NudgeCardItem orientation="vertical" key={i}>
                    {isOneOnOneSetup ? (
                      <>
                        <KnowTeamNudgeData
                          employeeName={displayName}
                          employeeProfilePhoto={profilePhoto}
                          scheduleDate={new Date(nextInstanceTS)}
                          duration={45}
                          variant="multiple"
                        />
                        <NudgeAction
                          onClick={() => oneOnOneInstanceExists && handleStart(masterId, instanceId)}
                          orientation="vertical"
                        >
                          Add to agenda
                        </NudgeAction>
                      </>
                    ) : (
                      <>
                        <KnowTeamNudgeData
                          employeeName={displayName}
                          employeeProfilePhoto={profilePhoto}
                          subTitle="Not Scheduled"
                          duration={45}
                          variant="multiple"
                        />
                        <NudgeAction
                          onClick={() =>
                            dispatch(
                              openCreateOneOnOneDrawer({
                                excludedParticipantIds: [],
                                employeeId: id,
                                employeeMiniProfile,
                                startDateTime: undefined,
                                duration: 0,
                                frequency: '',
                                participantId: 0,
                                isCalendarSynced: false,
                                relation: '',
                              })
                            )
                          }
                          orientation="vertical"
                        >
                          Create 1:1
                        </NudgeAction>
                      </>
                    )}
                  </NudgeCardItem>
                );
              })}
            </CarouselContainer>
          </Carousel>
        )}
      </CardContent>
    </Card>
  );
};

export default UpComingOneOnOneList;
